import React, { useState } from "react";
import { TabButtonProps } from "../../service/interfaces/Components";

const TabButton: React.FC<TabButtonProps> = ({ label, isActive, onClick }) => (
  <button
    onClick={onClick}
    type="button"
    className={`px-4 py-2 font-[500] text-[14px] w-[160px] rounded-full transition-all ${isActive ? "bg-[#444FBD] text-white" : "text-[#282828]"
      }`}
  >
    {label}
  </button>
);

// Props for CustomTabs Component
interface CustomTabsProps {
  tabs: string[]; // Array of tab labels
  activeTab?: string; // External active tab control
  initialActiveTab?: string; // Optional initial active tab
  onTabChange?: (tab: string) => void; // Callback for tab change
}

// CustomTabs Component
const CustomTabs: React.FC<CustomTabsProps> = ({
  tabs,
  activeTab: externalActiveTab,
  initialActiveTab,
  onTabChange,
}) => {
  const [internalActiveTab, setInternalActiveTab] = useState<string>(
    initialActiveTab || tabs[0]
  );

  // Use external activeTab if provided, otherwise use internal state
  const activeTab = externalActiveTab !== undefined ? externalActiveTab : internalActiveTab;

  const handleTabClick = (tab: string) => {
    if (externalActiveTab === undefined) {
      // Only update internal state if not controlled externally
      setInternalActiveTab(tab);
    }
    if (onTabChange) onTabChange(tab);
  };

  return (
    <div className="bg-white rounded-[50px] w-full overflow-x-auto">
      <div className="flex justify-center gap-2 px-2 py-2 w-max md:w-full md:justify-center">
        {tabs.map((tab) => (
          <TabButton
            key={tab}
            label={tab}
            isActive={activeTab === tab}
            onClick={() => handleTabClick(tab)}
          />
        ))}
      </div>
    </div>

  );
};

export default CustomTabs;
